/* eslint-disable sonarjs/no-duplicate-string */
import { Offers } from '../types';

const offers: Offers = [
  {
    id: 11,
    partner: 'ЛитРес',
    partnerSlug: 'litres',
    isActive: true,
    position: 4,
    image:
      '/img/offers/partner-litres.png, /img/offers/partner-litres@2x.png 2x, /img/offers/partner-litres@3x.png 3x',
    title: 'Книжная вселенная ЛитРес',
    description: 'Можно читать, а можно — слушать! Погружайтесь в книги, где и когда хотите',
    subscriptionOptions: {
      image:
        '/img/offers/offer-litres.png, /img/offers/offer-litres@2x.png 2x, /img/offers/offer-litres@3x.png 3x',
      title: 'ЛитРес',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Например, подписку на библиотеку ЛитРес — чтобы любимые книги были рядом и дома, и в машине, и на прогулке. Ведь их можно не только читать, но и слушать.</p>',
      items: [
        {
          id: 11,
          title: 'Книги от ЛитРес 3 месяца со скидкой 15%',
          description: 'Читайте 150 000 книг в каталоге ЛитРес с МегаФон Книгами',
          price: 535,
          priceOld: 630,
          serviceName: 'litres_3',
        },
        {
          id: 21,
          title: 'Книги от ЛитРес 6 месяцев со скидкой 20%',
          description: 'Читайте 150 000 книг в каталоге ЛитРес с МегаФон Книгам',
          price: 1000,
          priceOld: 1260,
          serviceName: 'litres_6',
        },
        {
          id: 31,
          title: 'Книги от ЛитРес 12 месяцев со скидкой 25%',
          description: 'Читайте 150 000 книг в каталоге ЛитРес с МегаФон Книгами',
          price: 1900,
          priceOld: 2555,
          serviceName: 'litres_12',
        },
        {
          id: 41,
          title: 'Книги+ от ЛитРес 3 месяца со скидкой 13%',
          description: 'Читайте и слушайте книги из каталога ЛитРес',
          price: 1400,
          priceOld: 1620,
          serviceName: 'litres_3_plus',
        },
        {
          id: 51,
          title: 'Книги+ от ЛитРес 6 месяцев со скидкой 16%',
          description: 'Читайте и слушайте книги из каталога ЛитРес',
          price: 2699,
          priceOld: 3240,
          serviceName: 'litres_6_plus',
        },
        {
          id: 61,
          title: ' Книги+ от в ЛитРес 12 месяцев со скидкой 32%',
          description: 'Читайте и слушайте книги из каталога ЛитРес',
          price: 4409,
          priceOld: 6570,
          serviceName: 'litres_12_plus',
        },
      ],
    },
  },
  {
    id: 21,
    partner: 'МегаФон Пресса',
    partnerSlug: 'megafon-press',
    isActive: true,
    position: 7,
    image:
      '/img/offers/partner-pressa.png, /img/offers/partner-pressa@2x.png 2x, /img/offers/partner-pressa@3x.png 3x',
    title: 'МегаФон Пресса',
    description: 'Все любимые издания — в вашем смартфоне',
    subscriptionOptions: {
      image:
        '/img/offers/offer-pressa.png, /img/offers/offer-pressa@2x.png 2x, /img/offers/offer-pressa@3x.png 3x',
      title: 'МегаФон Пресса',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Например, целую библиотеку статей и журналов с МегаФон Прессой – чтобы было, что полистать за утренним кофе в любимом кафе. А ещё – аудиостатьи, лекции и пересказы популярных книг, которые можно слушать где угодно.</p>',
      items: [
        {
          id: 11,
          title: '3 месяца со скидкой 45%',
          description: 'Читайте сотни изданий со всего мира - от Geo до Forbes (16+)',
          price: 399,
          priceOld: 720,
          serviceName: 'mfpress_3',
        },
        {
          id: 21,
          title: '6 месяцев со скидкой 48%',
          description: 'Читайте сотни изданий со всего мира - от Geo до Forbes (16+)',
          price: 700,
          priceOld: 1440,
          serviceName: 'mfpress_6',
        },
        {
          id: 31,
          title: '12 месяцев со скидкой 65%',
          description: 'Читайте сотни изданий со всего мира - от Geo до Forbes (16+)',
          price: 999,
          priceOld: 2920,
          serviceName: 'mfpress_12',
        },
      ],
    },
  },
  {
    id: 31,
    partner: 'MyBook',
    partnerSlug: 'mybook',
    isActive: true,
    position: 5,
    image:
      '/img/offers/partner-mybook.png, /img/offers/partner-mybook@2x.png 2x, /img/offers/partner-mybook@3x.png 3x',
    title: 'Книжные миры MyBook',
    description: 'Лучше слушать или читать? Не спорьте — отдыхайте как нравится',
    subscriptionOptions: {
      image:
        '/img/offers/offer-mybook.png, /img/offers/offer-mybook@2x.png 2x, /img/offers/offer-mybook@3x.png 3x',
      title: 'Книжные миры MyBook',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Например, подписку на библиотеку MyBook – доступ к самым популярным книгам и аудиокнигам со всего мира.</p>',
      items: [
        {
          id: 11,
          title: 'Книги от MyBook 3 месяца со скидкой 15%',
          description: 'Читайте любимые книги, где угодно',
          price: 550,
          priceOld: 649,
          serviceName: 'mybook_3',
        },
        {
          id: 21,
          title: 'Книги от MyBook 6 месяцев со скидкой 20%',
          description: 'Читайте любимые книги, где угодно',
          price: 1000,
          priceOld: 1250,
          serviceName: 'mybook_6',
        },
        {
          id: 31,
          title: 'Книги от MyBook 12 месяцев со скидкой 25%',
          description: 'Читайте любимые книги, где угодно',
          price: 1700,
          priceOld: 2290,
          serviceName: 'mybook_12',
        },
        {
          id: 41,
          title: 'Книги+ от MyBook 3 месяца со скидкой 12%',
          description: 'Читайте и слушайте любимые книги, где угодно',
          price: 1400,
          priceOld: 1590,
          serviceName: 'mybook_3_plus',
        },
        {
          id: 51,
          title: 'Книги+ от MyBook 6 месяцев со скидкой 20%',
          description: 'Читайте и слушайте любимые книги, где угодно',
          price: 2400,
          priceOld: 2999,
          serviceName: 'mybook_6_plus',
        },
        {
          id: 61,
          title: 'Книги+ от MyBook 12 месяцев со скидкой 20%',
          description: 'Читайте и слушайте любимые книги, где угодно',
          price: 4409,
          priceOld: 5490,
          serviceName: 'mybook_12_plus',
        },
      ],
    },
  },
  {
    id: 41,
    partner: 'МегаФон Подкасты',
    partnerSlug: 'podcasts',
    isActive: true,
    position: 8,
    image:
      '/img/offers/partner-podcast.png, /img/offers/partner-podcast@2x.png 2x, /img/offers/partner-podcast@3x.png 3x',
    title: 'Подкасты на каждый день',
    description: 'А ещё — саммари популярных книг и лекции от топовых спикеров в одной подписке',
    subscriptionOptions: {
      image:
        '/img/offers/offer-podcast.png, /img/offers/offer-podcast@2x.png 2x, /img/offers/offer-podcast@3x.png 3x',
      title: 'Подкасты на каждый день',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Например, подписку на МегаФон Подкасты – для тех, кто «любит ушами». Популярные каналы, злободневные дискуссии и аудиолекции обо всём на свете можно слушать, где угодно, не расходуя интернет по тарифу.</p>',
      items: [
        {
          id: 11,
          title: '3 месяца со скидкой 45%',
          description: 'Разнообразьте каждый день подкастом',
          price: 249,
          priceOld: 450,
          serviceName: 'podcasts_3',
        },
        {
          id: 21,
          title: '6 месяцев со скидкой 45%',
          description: 'Разнообразьте каждый день подкастом',
          price: 500,
          priceOld: 900,
          serviceName: 'podcasts_6',
        },
        {
          id: 31,
          title: '12 месяцев со скидкой 58%',
          description: 'Разнообразьте каждый день подкастом',
          price: 750,
          priceOld: 1825,
          serviceName: 'podcasts_12',
        },
      ],
    },
  },
  {
    id: 51,
    partner: 'СберЗвук',
    partnerSlug: 'sber-zvuk',
    isActive: true,
    position: 3,
    image:
      '/img/offers/partner-sber.png, /img/offers/partner-sber@2x.png 2x, /img/offers/partner-sber@3x.png 3x',
    title: 'Музыка в «СберЗвук»',
    description: 'Найдите саундтрек к каждому своему дню',
    subscriptionOptions: {
      image:
        '/img/offers/offer-sber-zvuk.png, /img/offers/offer-sber-zvuk@2x.png 2x, /img/offers/offer-sber-zvuk@3x.png 3x',
      title: 'Музыка в «СберЗвук»',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Например, подписку на музыкальное приложение«СберЗвук» (12+) – чтобы любимая музыка наполнила каждый день.</p>',
      items: [
        {
          id: 11,
          title: '3 месяца со скидкой 60%',
          description: '40 миллионов треков уже ждут, когда их добавят в плейлист!',
          price: 199,
          priceOld: 507,
          serviceName: 'sberzvuk_3',
        },
        {
          id: 21,
          title: '7 месяцев со скидкой 40%',
          description: '40 миллионов треков уже ждут, когда их добавят в плейлист!',
          price: 700,
          priceOld: 1183,
          serviceName: 'sberzvuk_7',
        },
      ],
    },
  },
  {
    id: 61,
    partner: 'IVI',
    partnerSlug: 'ivi',
    isActive: true,
    position: 1,
    image:
      '/img/offers/partner-ivi.png, /img/offers/partner-ivi@2x.png 2x, /img/offers/partner-ivi@3x.png 3x',
    title: 'Кино и сериалы в IVI',
    description: 'Огромная коллекция фильмов сразу на 5 устройствах',
    subscriptionOptions: {
      image:
        '/img/offers/offer-ivi.png, /img/offers/offer-ivi@2x.png 2x, /img/offers/offer-ivi@3x.png 3x',
      title: 'Кино и сериалы в IVI',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Например, подписку на онлайн-кинотеатр IVI (12+) – чтобы всегда точно знать, что посмотреть вечером. Это не трудно, когда у вас есть выбор из более 85 000 фильмов и сериалов без рекламы* с персональными подборками и рекомендациями. Сервис доступен на любом устройстве - смартфоне, планшете, ноутбуке, ПК или Smart TV.</p><p>*кроме встроенной в контент и ТВ-каналов</p> ',
      items: [
        {
          id: 11,
          title: '3 месяца со скидкой 58%',
          description: 'Тысячи фильмов и сериалов без рекламы',
          price: 499,
          priceOld: 1197,
          serviceName: 'ivi_3',
        },
        {
          id: 21,
          title: '12 месяцев со скидкой 58%',
          description: 'Тысячи фильмов и сериалов без рекламы',
          price: 1999,
          priceOld: 4788,
          serviceName: 'ivi_12',
        },
      ],
    },
  },
  {
    id: 71,
    partner: 'Okko',
    partnerSlug: 'okko',
    isActive: true,
    position: 2,
    image:
      '/img/offers/partner-okko.png, /img/offers/partner-okko@2x.png 2x, /img/offers/partner-okko@3x.png 3x',
    title: 'Фильмы и сериалы в Okko',
    description: 'Пригласите друзей на фильм — для этого даже в кинотеатр идти не обязательно',
    subscriptionOptions: {
      image:
        '/img/offers/offer-okko.png, /img/offers/offer-okko@2x.png 2x, /img/offers/offer-okko@3x.png 3x',
      title: 'Фильмы и сериалы в Okko',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Например, подписку на онлайн-кинотеатр Okko – все самые крутые фильмы, сериалы и мультфильмы в качестве Full HD и без рекламы. Ведь что может быть приятнее вечера в компании хорошего кино? 18+.</p>',
      items: [
        {
          id: 11,
          title: '«Лайт» на 3 месяца со скидкой 66%',
          description:
            'Здесь вас ждут отечественные фильмы и сериалы, а ещё — мировая классика кино',
          price: 199,
          priceOld: 597,
          serviceName: 'okko_3_lite',
        },
        {
          id: 21,
          title: '«Оптимум» на 3 месяца со скидкой 66%',
          description: 'Много зарубежных сериалов и фильмов + большой выбор российского кино',
          price: 399,
          priceOld: 1197,
          serviceName: 'okko_3_optimum',
        },
        {
          id: 31,
          title: '«Оптимум» на 6 месяцев со скидкой 70%',
          description: 'Много зарубежных сериалов и фильмов + большой выбор российского кино',
          price: 695,
          priceOld: 2394,
          serviceName: 'okko_6_optimum',
        },
        {
          id: 41,
          title: '«Спорт Лайт» на 12 месяцев со скидкой 51%',
          description: 'Лучшие моменты в матчах, обзоры турниров и спортивные передачи',
          price: 399,
          priceOld: 828,
          serviceName: 'okko_12_sport_lite',
        },
      ],
    },
  },
  {
    id: 81,
    partner: 'МегаФон ТВ',
    partnerSlug: 'megafon-tv',
    isActive: false,
    position: 6,
    image:
      '/img/offers/partner-mftv-osnovnoi.png, /img/offers/partner-mftv-osnovnoi@2x.png 2x, /img/offers/partner-mftv-osnovnoi@3x.png 3x',
    title: 'Пакет каналов в МегаФон ТВ',
    description: 'Собрали всё, что вы так любите, на МегаФон ТВ',
    subscriptionOptions: {
      image:
        '/img/offers/offer-mftv-osnovnoi.png, /img/offers/offer-mftv-osnovnoi@2x.png 2x, /img/offers/offer-mftv-osnovnoi@3x.png 3x',
      title: 'Пакет каналов в МегаФон ТВ',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Например, подписку сразу на 200 отечественных и зарубежных каналов в МегаФон ТВ – чтобы в любое время в любом месте был повод расслабиться и посмотреть любимые телепередачи.</p>',
      items: [
        {
          id: 11,
          title: '3 месяца со скидкой 29%',
          description: 'Популярные телеканалы со всего мира всегда под рукой',
          price: 849,
          priceOld: 1197,
          serviceName: 'mftv_3',
        },
        {
          id: 21,
          title: '6 месяцев со скидкой 37%',
          description: 'Популярные телеканалы со всего мира всегда под рукой ',
          price: 1499,
          priceOld: 2394,
          serviceName: 'mftv_6',
        },
      ],
    },
  },
  {
    id: 91,
    partner: 'ESET',
    partnerSlug: 'eset',
    isActive: true,
    position: 9,
    image:
      '/img/offers/partner-eset.png, /img/offers/partner-eset@2x.png 2x, /img/offers/partner-eset@3x.png 3x',
    title: 'Антивирус ESET',
    description: 'Подарить спокойствие — бесценно. Защитите 3 любых устройства от вирусов',
    subscriptionOptions: {
      image:
        '/img/offers/offer-eset.png, /img/offers/offer-eset@2x.png 2x, /img/offers/offer-eset@3x.png 3x',
      title: 'Антивирус ESET',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! Чувствовать безопасность в сети — важно. Ведь большую часть дня мы проводим в интернете — за работой или общением. С антивирусом ESET можно защитить сразу несколько гаджетов от вирусов и взлома мошенниками.</p>',
      items: [
        {
          id: 11,
          title: 'Антивирус ESET на 3 месяца со скидкой 30%',
          description:
            'Один лицензионный ключ сразу для трёх устройств — например, смартфона, планшета и компьютера',
          price: 315,
          priceOld: 450,
          serviceName: 'eset_3',
        },
        {
          id: 21,
          title: 'Антивирус ESET на 6 месяцев со скидкой 30%',
          description:
            'Один лицензионный ключ сразу для трёх устройств — например, смартфона, планшета и компьютера',
          price: 630,
          priceOld: 900,
          serviceName: 'eset_6',
        },
        {
          id: 31,
          title: 'Антивирус ESET на 12 месяцев со скидкой 30%',
          description:
            'Один лицензионный ключ сразу для трёх устройств — например, смартфона, планшета и компьютера',
          price: 1300,
          priceOld: 1800,
          serviceName: 'eset_12',
        },
      ],
    },
  },
  {
    id: 101,
    partner: 'Яндекс.Плюс',
    partnerSlug: 'yandex-plus',
    isActive: true,
    position: 0,
    image:
      '/img/offers/partner-yandex.png, /img/offers/partner-yandex@2x.png 2x, /img/offers/partner-yandex@3x.png 3x',
    title: 'Яндекс Плюс с МегаФоном',
    description: 'На работу — с музыкой. Домой — на такси с кешбэком. А вечером — любимый фильм',
    subscriptionOptions: {
      image:
        '/img/offers/offer-yandex-plus.png, /img/offers/offer-yandex-plus@2x.png 2x, /img/offers/offer-yandex-plus@3x.png 3x',
      title: 'Яндекс Плюс с МегаФоном',
      description:
        '<p>Угадать с подарком даже близкому человеку бывает непросто. Вот вам беспроигрышный вариант — дарите не вещи, а впечатления и эмоции! В мультиподписке «Яндекс Плюс с МегаФоном» есть куча приятных бонусов на каждый день: музыка без рекламы онлайн и офлайн, тысячи фильмов и сериалов на КиноПоиск HD, кешбэк от поездок на такси и многое другое. Ведь счастье складывается из мелочей, правда?</p>',
      items: [
        {
          id: 11,
          title: '3 месяца',
          description: 'Кешбэк, музыка и кино с Яндекс Плюс МегаФон',
          price: 199,
          priceOld: 597,
          serviceName: 'yandex_plus_3',
        },
        {
          id: 21,
          title: '6 месяцев',
          description: 'Кешбэк, музыка и кино с Яндекс Плюс МегаФон',
          price: 595,
          priceOld: 1194,
          serviceName: 'yandex_plus_6',
        },
        {
          id: 31,
          title: '12 месяцев',
          description: 'Кешбэк, музыка и кино с Яндекс Плюс МегаФон',
          price: 999,
          priceOld: 2388,
          serviceName: 'yandex_plus_12',
        },
      ],
    },
  },
];

export default offers;
